import { QuickView } from './quick-view/quick-view.interface';
import { SelectedQuickFilters } from '../containers/filters/pb-quick-filter/pb-quick-filter.interface';
import { ToSelectedQuickFilter } from '../../to-screen/containers/filter/to-quick-filter/to-quick-filter.interface';
import { QuickFilter } from './pb-screen.interface';
import {
  GeneralSetting,
  PlanningSetting,
  TmsActionCodeColorSetting,
  TruckFilters,
  WeekPlanningSetting
} from '../../setting-modal/setting-modal.interface';
import { UserSetup } from '../userSetup/userSetup-modal.interface';
import { IdNameAsStringObject } from './quick-view/id-name-as-string-object.interface';
import { QuickFilter as QuickFilterCp, SearchFilter } from "../../depot-in/models/depot-in.interface";
import { AdvancedFilter } from '../../shared/components/filter-line/filter-line.interface';
import { ButtonVisibility } from '../../shared/models/buttons-visibility';
import {
  WeekPlanningCapacitySlotColumnSelectionSetting
} from "../../planningBoard/containers/planning-content/models/capacity-slots/week-planning-capacity-slot-column-selection.setting";
import { UserAuthorization } from '../../users-authorizations/models/user-authorization.interface';

export interface ApplicationUser {
  shipModalColumnsOrder: string[],
  railModalColumnsOrder: string[],
  depotQuickViews: QuickView[];
  id: string;
  username: string;
  fullName: string;
  settings: UserSettings[];
  pbPreferences : PbPreferences;
  toPreferences: ToPreferences;
  orderlinePreferences: OrderLinePreferences;
  defaultPlanningZone: string;
  defaultDateFormat: string  ;
  Screens: Selectedscreen;
  defaultGridIcon: GridIconSetting[];
  toIcons: GridIconSetting[];
  defaultPlanDate: string;
  defaultTruckDepartments: string[];
  defaultPlanGroups: string[];
  defaultPlanGroupsForPlanningBlockScreen: string[];
  defaultPlanGroupsForDepotsScreens: string[];
  defaultPlanZone: string;
  defaultPlanDateRange : DefaultPlanDateRange;
  pbFixedPreferences: PbFixedPreferences;
  defaultAgendaDateRange: string;
  defaultAgendaPlanningGroup: IdNameAsStringObject;
  defaultAgendaPlanningZone: IdNameAsStringObject;
  defaultTruckAgendaDateRange: string;
  defaultTruckAgendaPlanningGroup: IdNameAsStringObject;
  defaultTruckAgendaPlanningZone: IdNameAsStringObject;
  pixelsPerPlanningBlock: number;
  enableContainerSwap: boolean ;
  suggestPlanDateOption: string;
  buttonsVisibility: ButtonVisibility[];

  checkDateCompatibility: boolean;
  usePopupScreenForEditingOrderlines: boolean;
  planningToolLanguage: string;
  enableBargeAndCaptainLabels: boolean;

  truckFilters: TruckFilters;

  weekPlanningCapacitySlotColumnSelectionSettings: WeekPlanningCapacitySlotColumnSelectionSetting[];

  weekPlanningSetting: WeekPlanningSetting;
  tmsActionCodeColorSetting: TmsActionCodeColorSetting;
  planningSetting: PlanningSetting;
  generalSetting: GeneralSetting;
  userSetup: UserSetup;
  defaultPlanSorting: string;
  showAbsentDriversPlan: boolean;
  depotOutSelectedColumns: Column[];
  depotInSelectedColumns: Column[];
  stackerSelectedColumns: Column[];
  depotOutSavedAdvancedFilters: AdvancedFilter[];
  depotInSavedAdvancedFilters: AdvancedFilter[];
  quickViews: QuickView[];
  planningBlocksPriority: PlanningBlocksPriority[];
  planningGroups: any[];
  siteNumber : string ;
  weekPlanningPreferences: WeekPlanningPreferences;
  depotInPreferences : DepotInPreferences;
  depotOutPreferences : DepotOutPreferences;
  depotOutGridIcons : GridIconSetting[];
  depotInGridIcons: GridIconSetting[];
  orderlinesDockSelectedColumns: Column[];
  conflictsDockSelectedColumns: Column[];
  cargoDockSelectedColumns: Column[];
  equipmentDockSelectedColumns: Column[];
  documentsDockSelectedColumns: Column[];
  planningBlocksDockSelectedColumns: Column[];
  serverSideFiltering: boolean;
  enableOptimisticUi: boolean;
  /** Tenant-wide master switch for the planning-board optimistic UI (Settings → Optimistic UI). */
  enableOptimisticUiPlanningBoard: boolean;
  /** This user's own opt-out for the planning-board optimistic UI; only applies while the master switch is on. */
  enableOptimisticUiPlanningBoardUser: boolean;
  userAuthorization: UserAuthorization;
}

export interface DefaultPlanDateRange {
  defaultPlanDateFrom : string ,
  defaultPlanDateUntil : string
}

export interface UserSettings {
  id?: string;
  setting: Setting;
  value: string;
  scope: Scope;
  scopeValue: string;
  userId: string;
  view: View;
}

export interface View {
  name: string;
  id: string;
}

export interface PbPreferences {
  fontSize: string;
  selectedColumns: Column[];
  savedAdvancedFilters: AdvancedFilter[];
  quickViews: QuickView[];
  selectedQuickFilters?: SelectedQuickFilters;
  quickFilter?: QuickFilter;
}

export interface PbFixedPreferences {
  fixedQuickFilter?: QuickFilter;
  isFixedQuickFilter?: SelectedQuickFilters;
}

export interface ToPreferences {
  selectedToColumns: Column[];
  selectedToQuickFilters?: ToSelectedQuickFilter;
  fontSize: string;
}

export interface OrderLinePreferences {
  OrderLineColumnSelection: Column[];
  PbOrderLineColumnSelection: Column[];
}

export interface PlanningBoard {
  selectedColumns: Column[];
  savedAdvancedFilters: AdvancedFilter[];
  quickViews: QuickView[];
  selectedQuickFilters?: SelectedQuickFilters;
  selectedToColumns: Column[];
  OrderLineColumnSelection: Column[];
}

export interface Column {
  name: string;
  width: number;
  locked: boolean;
}

export enum EnumGridIconSetting {
  Scanning, Customs, Weighing, ADR, T1, Temperature, HighValue, Conflicts , Notifications
}

export interface GridIconSetting {
  id: number; isVisible: boolean; name:string;
}

export interface Setting {
  id?: string;
  name: string;
  settingType: SettingType;
}

export enum SettingType {
  Single,
  Multiple
}

export enum Scope {
  None,
  Global,
  Module,
  User
}


export class Selectedscreen {
  depotIn: DocumentToBePrinted[];
  depotOut: DocumentToBePrinted[];
  pbscreen: DocumentToBePrinted[];
  pbdetails: DocumentToBePrinted[];
  toscreen: DocumentToBePrinted[];
  todetails: DocumentToBePrinted[];
  planningBoard: DocumentToBePrinted[];
}
export class DocumentToBePrinted {
  name: string;
}

export interface PlanningBlocksPriority{
  id: number,
  priority: boolean;
}

export interface DepotInPreferences
{
  selectedQuickFilters : SelectedDepotInQuickFilters,
  selectedSearchFilters: SelectedDepotInSearchFilters,
  quickFilter : QuickFilterCp,
  searchFilter: SearchFilter,
  fontSize: string,
}

export interface WeekPlanningPreferences {
  fontSize: string;
  tabletMode: boolean;
}

export interface DepotOutPreferences
{
  selectedQuickFilters : SelectedDepotOutQuickFilters,
  quickFilter : QuickFilterCp,
  selectedSearchFilters: SelectedDepotOutSearchFilters,
  searchFilter: SearchFilter,
  fontSize: string;
}


export class SelectedDepotInQuickFilters {
  isplanningStateActive: boolean;
  isfirstActionActive: boolean;
  islastActionActive: boolean;
  isloadingPlaceActive: boolean;
  isunLoadingPlaceActive: boolean;
  iscustomerActive: boolean;
  iscontainerStatusActive: boolean;
  isunloadDateFromActive: boolean;
  isunloadDateToActive: boolean;
  ispickupDateFromActive: boolean;
  ispickupDateToActive: boolean;
  ispbFirstCollectionFromActive: boolean;
  isspecificPbFirstCollectionFromActive: boolean;
  isspecificClosingActive: boolean;
  isclosingActive: boolean;
  iscontainerTypeActive: boolean;
  islatestLocationCodeActive: boolean;
  iscarrierActive: boolean;
  isplanningGroupsActive: boolean;
  isVGMClosingActive: boolean;
  isSpecificVgmClosingActive: boolean;
  isSpecificBookedDateTimeFrom: boolean;
  isSpecificBookedDateTimeUntil: boolean;

}



export class SelectedDepotInSearchFilters {
  isplanningStateActive: boolean;
  isfirstActionActive: boolean;
  islastActionActive: boolean;
  isloadingPlaceActive: boolean;
  isunLoadingPlaceActive: boolean;
  iscustomerActive: boolean;
  iscontainerStatusActive: boolean;
  isunloadDateFromActive: boolean;
  isunloadDateToActive: boolean;
  ispickupDateFromActive: boolean;
  ispickupDateToActive: boolean;
  ispbFirstCollectionFromActive: boolean;
  isspecificPbFirstCollectionFromActive: boolean;
  isspecificClosingActive: boolean;
  isclosingActive: boolean;
  iscontainerTypeActive: boolean;
  islatestLocationCodeActive: boolean;
  iscarrierActive: boolean;
  isplanningGroupsActive: boolean;
  isVGMClosingActive: boolean;
  isSpecificVgmClosingActive: boolean;
  isSpecificBookedDateTimeFrom: boolean;
  isSpecificBookedDateTimeUntil: boolean;
  isorderNoActive: boolean;
  isfileNoActive: boolean;
  isreference1Active: boolean;
  iscontainerNoActive: boolean;
  isdriverFullNameActive: boolean;
  isvesselNameExportActive: boolean;
  isvesselNameImportActive: boolean;
  isreference2Active: boolean;
  isbookedDateFromActive: boolean;
  isbookedDateUntilActive: boolean;
  isdepotInReference1Active: boolean;
  isdepotOutReference1Active: boolean;
  islocationCodeActive: boolean;
}
export class SelectedDepotOutQuickFilters {
  isplanningStateActive: boolean;
  isfirstActionActive: boolean;
  islastActionActive: boolean;
  isloadingPlaceActive: boolean;
  isunLoadingPlaceActive: boolean;
  iscustomerActive: boolean;
  iscontainerStatusActive: boolean;
  isunloadDateFromActive: boolean;
  isunloadDateToActive: boolean;
  ispbFirstCollectionFromActive: boolean;
  isclosingActive: boolean;
  isspecificPbFirstCollectionFromActive: boolean;
  isspecificClosingActive: boolean;
  ispickupDateFromActive: boolean;
  isStartDateActive: boolean;
  isEndDateActive: boolean;
  ispickupDateToActive: boolean;
  iscontainerTypeActive: boolean;
  islatestLocationCodeActive: boolean;
  iscarrierActive: boolean;
  isplanningGroupsActive: boolean;
  isVGMClosingActive: boolean;
  isSpecificVgmClosingActive:boolean;
  isSpecificBookedDateTimeFrom: boolean;
  isSpecificBookedDateTimeUntil: boolean;
}
export class SelectedDepotOutSearchFilters {
  isplanningStateActive: boolean;
  isfirstActionActive: boolean;
  islastActionActive: boolean;
  isloadingPlaceActive: boolean;
  isunLoadingPlaceActive: boolean;
  iscustomerActive: boolean;
  iscontainerStatusActive: boolean;
  isunloadDateFromActive: boolean;
  isunloadDateToActive: boolean;
  ispickupDateFromActive: boolean;
  ispickupDateToActive: boolean;
  ispbFirstCollectionFromActive: boolean;
  isspecificPbFirstCollectionFromActive: boolean;
  isspecificClosingActive: boolean;
  isclosingActive: boolean;
  iscontainerTypeActive: boolean;
  islatestLocationCodeActive: boolean;
  iscarrierActive: boolean;
  isplanningGroupsActive: boolean;
  isVGMClosingActive: boolean;
  isSpecificVgmClosingActive: boolean;
  isSpecificBookedDateTimeFrom: boolean;
  isSpecificBookedDateTimeUntil: boolean;
  isorderNoActive: boolean;
  isfileNoActive: boolean;
  isreference1Active: boolean;
  iscontainerNoActive: boolean;
  isdriverFullNameActive: boolean;
  isvesselNameExportActive: boolean;
  isvesselNameImportActive: boolean;
  isreference2Active: boolean;
  isbookedDateFromActive: boolean;
  isbookedDateUntilActive: boolean;
  isdepotInReference1Active: boolean;
  isdepotOutReference1Active: boolean;
  islocationCodeActive: boolean;
}




